import {REGEX} from "./constant";
import CryptoJS from 'crypto-js'

export const Decryption = (data) => {
    try {
        if (process.env.REACT_APP_ENC_KEY) {
            const bytes = CryptoJS.AES.decrypt(data, process.env.REACT_APP_ENC_KEY);
            return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        } else return data;
    } catch (e) {
        return false;
    }
};
export const Encryption = (data) => {
    if (process.env.REACT_APP_ENC_KEY) return CryptoJS.AES.encrypt(JSON.stringify(data), process.env.REACT_APP_ENC_KEY).toString();
    else return data;
};

export function checkMinLength(value, length) {
    return value && value.length >= length
}

export function checkUppercase(value) {
    return (REGEX.upperCase.test(value));
}

export function checkLowercase(value) {
    if (value) return (REGEX.lowerCase.test(value));
    else return false
}

export function checkNumeric(value) {
    return REGEX.number.test(value)
}

export function checkSpecialCharacter(value) {
    return REGEX.specialChar.test(value)
}


export function handleError(set, msg) {
    set(msg)
    setTimeout(() => set(""), 5000)
}

export const socketHandler = (response) => {
    if (typeof response === 'string') return Decryption(response);
    else return response
}

export const isMobileDevice = () => {
    return ('ontouchstart' in document.documentElement);
}

export const isElectron = () =>
    (typeof window !== 'undefined' && typeof window.process === 'object' && window.process.type === 'renderer') ||
    (typeof process !== 'undefined' && typeof process.versions === 'object' && !!process.versions.electron) ||
    (typeof navigator === 'object' && typeof navigator.userAgent === 'string' && navigator.userAgent.indexOf('Electron') >= 0)

export const getLabelValue = (arrName = [], include, key = 'name') => {
    const finalArray = []
    arrName?.forEach(e => {
        let data = {label: e[key], value: e._id}
        if (key?.length !== 0 && include) data[include] = e[include]
        finalArray?.push(data)
    })
    return finalArray
}
